// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/4038
import type { PAPEventGeneric } from "../base/event";
import type { FileDownloadStatus } from "../enums/file_download_status";

// Event_name: 'close.result_preview_modal'
// Description: Close result preview modal
// Owner: dash-exp-find-and-discover
export type Close_ResultPreviewModal = PAPEventGeneric<
  'previews',
  'close',
  'result_preview_modal',
  {
    // Unique identifier for a viewing session of a preview
    previewModalUuid?: string;
    // Represents the latency in downloading a file
    fileDownloadLatency?: number;
    // Status of the content fetch operation (intended for the preview modal, capturing whether the preview content loaded successfully, failed, or timed out).
    fileDownloadStatus?: FileDownloadStatus;
  }
>;

export function PAP_Close_ResultPreviewModal(properties?: Close_ResultPreviewModal['properties']): Close_ResultPreviewModal {
  return <Close_ResultPreviewModal>{
    class: 'previews',
    action: 'close',
    object: 'result_preview_modal',
    properties,
  };
}
